import { thunk, action } from 'easy-peasy'

import { DOCUMENT_TYPE_ENUM } from '@24slg/database-schemas/enums'

import { documentService } from 'services'

const _states = {
  isFetched: false,
  bookingDetail: null,
  loading: false,
  showPaymentMethodError: false,
}

const _actions = {
  reset: action(() => {
    return {
      ..._states,
    }
  }),
  setIsFetched: action((state, payload) => {
    state.isFetched = payload
  }),
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  setBookingDetail: action((state, payload) => {
    const memoField = {}
    if (state?.bookingDetail?.contactShopOptions) {
      memoField.contactShopOptions = state?.bookingDetail?.contactShopOptions
    }
    state.bookingDetail = {
      ...memoField,
      ...payload,
    }
  }),
  setShowPaymentMethodError: action((state, payload) => {
    state.showPaymentMethodError = payload
  }),
}

const _thunks = {
  getBookingDetail: thunk(async (actions, payload) => {
    const id = payload

    actions.setIsFetched(false)

    return await documentService({
      method: 'post',
      url: '/documentIndex/query?documentIndex',
      data: {
        where: [{ id, filter: 'my-facility' }],
        relations: [
          'latestDocumentRevisionIndex.quotation.customerShippingAndWorkingAddress',
          'latestDocumentRevisionIndex.quotation.customerContactPerson',
          'latestDocumentRevisionIndex.quotation.saleContract',
          'latestDocumentRevisionIndex.saleOrder.customerShippingAndWorkingAddress',
          'latestDocumentRevisionIndex.saleOrder.customerContactPerson',
          'latestDocumentRevisionIndex.saleOrder.saleContract',
          'latestDocumentRevisionIndex.projectDocumentIndex',
        ],
      },
    })
      .then(async res => {
        const data = res?.data?.data?.[0]

        const documentType = data?.documentType

        let primaryFieldName = ''
        if (documentType === DOCUMENT_TYPE_ENUM.SQT) {
          primaryFieldName = 'quotationItem'
        } else if (documentType === DOCUMENT_TYPE_ENUM.SO) {
          primaryFieldName = 'saleOrderItem'
        }

        const items = await documentService({
          method: 'post',
          url: `/${primaryFieldName}/query`,
          data: {
            where: [
              {
                documentRevisionIndexId: data?.latestDocumentRevisionIndexId,
                filter: 'my-facility',
              },
            ],
            relations: ['product.subCategory', 'product.category'],
            order: {
              itemNumber: 'ASC',
            },
          },
        }).then(res => res.data.data)

        const newData = {
          ...data,
          items,
        }

        actions.setBookingDetail(newData)

        return newData
      })
      .finally(() => {
        actions.setIsFetched(true)
      })
  }),
}

const bookingModal = {
  ..._states,
  ..._actions,
  ..._thunks,
}

export default bookingModal
